import React, { useEffect, useState } from "react";
import { ChangeTitle } from "../../helpers/Reusable";
import { getCookie } from "../../helpers/CookieComponent";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import ClipLoader from "react-spinners/ClipLoader";

const MyOrderDetails = () => {
  ChangeTitle("My Order Detail");
  const orderId = getCookie("myoid");
  const [orderData, setOrderData] = useState({});
  const [loading, setLoading] = useState(true);
  const [invoice, setInvoice] = useState("");

  // OrderDetail Api Call
  const viewOrderDetail = async (id) => {
    setLoading(true);
    const param = {
      orderId: id,
    };
    var response = await postData(
      "private/order/user/detail",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setOrderData(data);
      setLoading(false);
    } else {
      console.log(response.data);
      console.log(response.data.message);
      setLoading(false);
    }
  };
  const viewInvoice = async (id) => {
    const param = {
      orderId: id,
    };
    var response = await postData(
      "private/order/user/invoice",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.invoice;
      setInvoice(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewOrderDetail(orderId);
    viewInvoice(orderId);
  }, [orderId]);

  if (loading) {
    return (
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="relative xxl:container mx-auto">
          <div className="w-full h-[70vh] absolute top-1/2 flex items-center justify-center gap-5 loading">
            <ClipLoader
              color={"#2c3451"}
              loading={loading}
              size={40}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            <span className="" style={{ display: "block" }}>
              Loading...{" "}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="lg:w-[90%] xl:w-[80%] mx-auto">
            <div className="flex md:flex-row flex-col justify-between md:gap-20 p-[1rem] md:p-[2rem] mb-[3rem] myod-part1">
              <div className="myodp1-p1">
                <div className="flex gap-2 mb-2">
                  <h1 className="myodp1p1-title">Username:</h1>
                  <h2 className="myodp1p1-title2">
                    {orderData.orderDetail && orderData.orderDetail.userName}
                  </h2>
                </div>
                <div className="flex gap-2 mb-2">
                  <h1 className="myodp1p1-title">Payment:</h1>
                  <h2 className="myodp1p1-title2">
                    {orderData.orderDetail && orderData.orderDetail.payment}
                  </h2>
                </div>
                <div className="flex gap-2 mb-2">
                  <h1 className="myodp1p1-title">Order placed:</h1>
                  <h2 className="myodp1p1-title2">
                    {orderData.orderDetail && orderData.orderDetail.orderPlaced}
                  </h2>
                </div>
                <div className="flex gap-2 mb-2">
                  <h1 className="myodp1p1-title">Total:</h1>
                  <h2 className="myodp1p1-title2">
                    {orderData.orderDetail && orderData.orderDetail.total}{" "}
                    {orderData.paymentDetail &&
                      orderData.paymentDetail.currency}
                  </h2>
                </div>
              </div>
              <div className="relative myodp1-p2 h-auto">
                <div className="flex gap-2 md:mb-0 mb-5">
                  <h1 className="myodp1p1-title">Order:</h1>
                  <h2 className=" myodp1p1-title2">
                    {orderData.orderDetail && orderData.orderDetail.orderCode}
                  </h2>
                </div>
                <div className="w-full flex justify-end md:absolute md:bottom-0">
                  <a
                    href={invoice}
                    target="_blank"
                    className="cursor-pointer btn-invoice"
                  >
                    Invoice
                  </a>
                </div>
              </div>
            </div>
            <div className="w-full mb-5">
              <div
                className={`w-max ${
                  orderData?.orderDetail?.status === "pending"
                    ? "myod-status-p"
                    : orderData?.orderDetail?.status === "completed"
                    ? "myod-competed"
                    : "myod-status-c"
                }`}
              >
                {orderData.orderDetail &&
                orderData.orderDetail.status &&
                orderData.orderDetail.status == "pending"
                  ? "Pending"
                  : orderData.orderDetail.status == "cancel"
                  ? "Cancel"
                  : orderData.orderDetail.status == "completed"
                  ? "Completed"
                  : ""}
              </div>
            </div>
            <div className="mb-[3rem] myod-products">
              {orderData.orderBook &&
                orderData.orderBook.map((data) => (
                  <div className="flex gap-5 md:gap-10 p-[1rem] md:p-[2rem] myodp-box">
                    <div className="w-max">
                      <img
                        className="w-[10rem] md:w-[15rem]"
                        src={data.bookDetail && data.bookDetail.bookImage}
                        alt=""
                      />
                    </div>
                    <div className="w-full flex md:flex-row flex-col justify-between">
                      <div>
                        <h1 className="leading-none mb-2 myodpb-name">
                          {data.bookDetail && data.bookDetail.title}
                        </h1>
                        <div className="flex gap-2">
                          <h2 className="font-bold myodpb-title1">Quantity:</h2>
                          <h2 className="font-bold myodpb-title2">
                            {data.quantity}
                          </h2>
                        </div>
                        <h2 className="font-bold mb-5 myodpb-title1">
                          {data.price}{" "}
                          {orderData.paymentDetail &&
                            orderData.paymentDetail.currency}
                        </h2>
                      </div>
                      <div>
                        <div className="flex gap-2">
                          <h2 className="myodpb-title1">Order:</h2>
                          <h2 className="myodpb-title2">
                            {orderData.orderDetail &&
                              orderData.orderDetail.orderCode}
                          </h2>
                        </div>
                        <div className="flex gap-2">
                          <h2 className="myodpb-title1">Order placed:</h2>
                          <h2 className="myodpb-title2">
                            {orderData.orderDetail &&
                              orderData.orderDetail.orderPlaced}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="w-full flex lg:flex-row gap-[3rem] lg:gap-20 flex-col">
              <div className="lg:w-[60%] p-[1rem] md:p-[2rem] h-max myod-address">
                <div className="w-full mb-[1%] flex items-center justify-between">
                  <h1 className="myoda-title">Shipping address</h1>
                </div>
                <div className="w-full p-[1rem] md:p-[2rem] myoda-box">
                  <div className="w-full">
                    <h1 className="mb-[1%] myodab-name">
                      {orderData.address && orderData.address.fullName}
                    </h1>
                    <h3 className="mb-[1%] myodab-address">
                      {orderData.address.flatFloorNo},{" "}
                      {orderData.address.streetRoadNo},{" "}
                      {orderData.address.location}, {orderData.address.city}-{" "}
                      {orderData.address.pincode}
                    </h3>
                    <h3 className="myodab-mobileno">
                      {orderData.address.mobileNumber}
                    </h3>
                  </div>
                </div>

                {/* Show billing address only if it exists and is different from shipping address */}
                {orderData.billingAddress &&
                  orderData.billingAddress._id &&
                  orderData.address._id !== orderData.billingAddress._id && (
                    <>
                      <div className="w-full mt-[2rem] mb-[1%] flex items-center justify-between">
                        <h1 className="myoda-title">Billing address</h1>
                      </div>
                      <div className="w-full p-[1rem] md:p-[2rem] myoda-box">
                        <div className="w-full">
                          <h1 className="mb-[1%] myodab-name">
                            {orderData.billingAddress.fullName}
                          </h1>
                          <h3 className="mb-[1%] myodab-address">
                            {orderData.billingAddress.flatFloorNo},{" "}
                            {orderData.billingAddress.streetRoadNo},{" "}
                            {orderData.billingAddress.location},{" "}
                            {orderData.billingAddress.city}-{" "}
                            {orderData.billingAddress.pincode}
                          </h3>
                          <h3 className="myodab-mobileno">
                            {orderData.billingAddress.mobileNumber}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}
              </div>
              <div className="lg:w-[40%] myod-payment">
                <div className="w-full flex items-center justify-between mb-[5%] gap-5">
                  <h1 className="w-[60%] sm:w-[40%] md:w-[30%] lg:w-[90%] xl:w-[57%] myodp-title">
                    Payment details
                  </h1>
                  <div className="w-full myodp-line"></div>
                </div>
                <div className="w-full mb-2">
                  <div className="w-full flex justify-between myodp-title1">
                    <h1 className="w-max">Item</h1>
                    <h2 className="w-max">
                      {orderData &&
                        orderData.paymentDetail &&
                        orderData.paymentDetail.item}
                    </h2>
                  </div>
                </div>
                <div className="w-full mb-2">
                  <div className="w-full flex justify-between myodp-title1">
                    <h1 className="w-max">Subtotal</h1>
                    <h2 className="w-max">
                      {orderData &&
                        orderData.paymentDetail &&
                        orderData.paymentDetail.subTotal}{" "}
                      {orderData.paymentDetail &&
                        orderData.paymentDetail.currency}
                      /-
                    </h2>
                  </div>
                </div>
                <div className="w-full mb-2">
                  <div className="w-full flex justify-between myodp-title1">
                    <h1 className="w-max">GST @ 18%</h1>
                    <h2 className="w-max">
                      {orderData &&
                        orderData.paymentDetail &&
                        orderData.paymentDetail.GST}{" "}
                      {orderData.paymentDetail &&
                        orderData.paymentDetail.currency}
                      /-
                    </h2>
                  </div>
                </div>
                {orderData &&
                  orderData.paymentDetail &&
                  orderData.paymentDetail.discount && (
                    <div className="w-full mb-[2%]">
                      <div className="w-full flex justify-between myodp-title1">
                        <h1 className="w-max">Discount</h1>
                        <h2 className="w-max">
                          {orderData.paymentDetail.discount}{" "}
                          {orderData.paymentDetail &&
                            orderData.paymentDetail.currency}
                          /-
                        </h2>
                      </div>
                    </div>
                  )}
                <div className="w-full">
                  <div className="w-full flex justify-between myodp-title2">
                    <h1 className="w-max">Grand total</h1>
                    <h2 className="w-max">
                      {orderData &&
                        orderData.paymentDetail &&
                        orderData.paymentDetail.grandTotal}{" "}
                      {orderData.paymentDetail &&
                        orderData.paymentDetail.currency}
                      /-
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyOrderDetails;
